import { render, staticRenderFns } from "./swarmReport.vue?vue&type=template&id=856f9660&scoped=true&"
import script from "./swarmReport.vue?vue&type=script&lang=tsx&"
export * from "./swarmReport.vue?vue&type=script&lang=tsx&"
import style0 from "./swarmReport.vue?vue&type=style&index=0&id=856f9660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f9660",
  null
  
)

export default component.exports